import { net } from 'zf-web-infra';
import { CONFIG } from 'config';
import type * as Types from '../types';

export class LoginService {

  async login(data: Types.LoginParams): Promise<Types.LoginResponse> {
    let url = '/api/account/login';
    if (CONFIG.BANU_HOSTS.includes(location.hostname)) {
      url = '/api/account/banuLogin';
    }
    return await net.post<Types.LoginResponse>(url, data);
  }

  async enableMigration(code: string): Promise<boolean> {
    return await net.get('/api/account/trainingEnableMigration', { code });
  }

  async captcha(): Promise<Types.CaptchaResponse> {
    return await net.get<Types.CaptchaResponse>('/api/account/captcha');
  }

}
